module.exports = __webpack_public_path__ + "static/media/modal-close.bf755835.svg";